<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Client Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">

      <!-- <v-list two-line>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-item-title><strong>Name</strong></v-list-item-title>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-content>
            <v-list-item-title><strong>Mobile</strong></v-list-item-title>
            <v-list-item-title>{{ item.mobile }}</v-list-item-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-content>
            <v-list-item-title><strong>Email</strong></v-list-item-title>
            <v-list-item-title>{{ item.email }}</v-list-item-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-content>
            <v-list-item-title><strong>Address</strong></v-list-item-title>
            <v-list-item-title>{{ item.address || "-" }}</v-list-item-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-content>
            <v-list-item-title><strong>Notes</strong></v-list-item-title>
            <v-list-item-title>{{ item.notes }}</v-list-item-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list> -->
      <div v-for="prop in clientProps">
      <strong>{{ prop.title }}</strong><br>
      <p>{{ item[prop.key] }}</p>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
export default {
  props: ["item"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        mobile: "",
        email: "",
        notes: "",
        address: "",
      },
      // categories: []
      clientProps: [
        {title: "Name", key: 'name'},
        {title: "Mobile", key: 'mobile'},
        {title: "Email", key: 'email'},
        {title: "Address", key: 'address'},
        {title: "Notes", key: 'notes'},
      ]
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addClientForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addClientForm.reset();
    },
    resetValidation() {
      this.$refs.addClientForm.resetValidation();
    },
    clearForm() {
      this.newItem.name = "";
      this.newItem.mobile = "";
      this.newItem.email = "";
      this.newItem.address = "";
      this.newItem.notes = "";
    },
    newItemDo() {
      if (this.$refs.addClientForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/client", this.newItem).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
